import React, { useEffect } from "react";
import BreadCrumb from "../../../../../layout/BreadCrumb";
import { useDispatch, useSelector } from "react-redux";
import svg74 from "../../../../../assets/svg/svg74.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { Descriptions } from "antd";
import { fetchData } from "../../../../../features/fetch/fetchSlice";
import moment from "moment";

function ServicePerfView() {
  const dispatch = useDispatch();
  const { search } = useLocation();
  const queryParams1 = new URLSearchParams(search);
  const tab = queryParams1.get("tab");

  const url = "performance_metric/fetch_performancemetrics";

  const location = useLocation();
  const queryParams = new URLSearchParams(location?.search);
  const perfType = queryParams.get("perfType");

  const { saving } = useSelector((state) => state.save);
  const { activeObjOrganized, activeObjSchemes, loading, data } =
    useSelector((state) => ({
      activeObjOrganized: state.obj.activeObj[perfType],
      activeObjSchemes: state.obj.activeObj["schemes"],
      loading: state.fetch.loading,
      data: state.fetch.data[url] || [],
    }));

  const svgMap = {
    svg74,
  };
  const processedData = data?.map((item) => ({
    ...item,
    svg: svgMap[item?.kpisSvg],
  }));

  const groupedByType = data?.reduce((acc, curr) => {
    const type = curr?.metrType || "Others";
    if (!acc[type]) acc[type] = [];
    acc[type]?.push(curr);
    return acc;
  }, {});

  const renderDescriptions = (groupedMetrics) => {
    return Object?.entries(groupedMetrics)?.map(([metrType, metrics]) => {
      const items = metrics.map((metric) => ({
        key: metric?.metrId,
        label: metric?.metrLabel,
        children: metric?.mvalValue || "—",
      }));

      return (
        <div key={metrType}>
          <div className="custom-title mt-[2.5rem]">{metrType}</div>
          <Descriptions
            column={2}
            colon={false}
            items={items}
            layout="vertical"
          />
        </div>
      );
    });
  };

  async function fetchTableData() {
    await dispatch(
      fetchData({
        url: url,
        perfType: perfType,
        mvalSchId: activeObjOrganized?.mvalSchId,
        mvalCreatedTime:activeObjOrganized?.mvalCode,
        limit: null,
        start: 0,
      })
    );
  }

  useEffect(() => {
    fetchTableData();
  }, []);

  return (
    <div className="flex flex-col min-h-[80vh]">
      <BreadCrumb
        breadcrumbs={[
          { title: "Schemes Overview", path: "/scheme/scheme-overview" },
          { title: "Public", path: "/scheme/public-scheme" },
          { title: "Public View", path: "/scheme/public-scheme-view" },
          {
            title: `Performance Indicators ${activeObjSchemes?.schName}`,
            path: `/rob/scheme/indicators-list?tab=${tab}`,
          },
          { title: `Organized Performance View` },
        ]}
      />
      <div className="white_card mt-[1.25rem] flex-1">
        <span className="form-add-h">Service Delivery Performance </span>
        <div className="typography_2 mt-[1rem] flex items-center gap-x-[1rem]">
          <span>{activeObjSchemes?.schName}</span>
          <span>•</span>
          <span>
            Date:{" "}
            {moment(activeObjOrganized?.irrismCreatedDate).format("DD-MM-YYYY")}
          </span>
        </div>

        <div className="mt-[2.5rem] grid lg:grid-cols-3 grid-cols-1 gap-[1.75rem] h-full">
          {processedData &&
            processedData.map((item, index) => (
              <div
                key={index}
                className="rounded-[.75rem] border border-[#D6E1F5] bg-white p-[1rem]  flex flex-col"
              >
                <div className="paragraph_paragraph_bb13 !font-[500] mb-[10px]">
                  {item?.kpisKpi}
                </div>

                <div className="mt-[2rem] grid grid-cols-2 items-center justify-between font-interSans gap-[1.25rem]">
                  {item?.values?.map((val, idx) => (
                    <div key={idx} className="flex flex-col gap-y-[.5rem]">
                      <span className="text-[#050505] font-[400] font-interSans text-[.75rem]">
                        {val?.kpisdName}
                      </span>
                      <span className="text-[#050505] text-[1.125rem] font-interSans font-[500] flex items-center ">
                        {val?.kpisdCode}{" "}
                        <img
                          src={item?.svg}
                          alt={`icon-${idx}`}
                          className="ml-1"
                        />
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
        </div>

        {renderDescriptions(groupedByType)}
      </div>
    </div>
  );
}

export default ServicePerfView;
